export default __webpack_public_path__ + "static/media/logo-fundacion.6e53b5e1.png";